import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import jonathan from "../../assets/images/speakers/jonathan.JPG";

function Jonathan() {
  return (
    <>
    <div class="header">
      <div class="header-content">
        <div class="left">
          <div class="header-box">
            <h1 className="title">Q<sup>3</sup> Initiative: QREATE @ UMD</h1>
          </div>
          <p>September 12, 2025 - September 13, 2025</p>
          <p>University of Maryland, College Park</p>
          <p>Stamp Student Union: Colony Ballroom</p>
        </div>
        <div className="right">
          <img src={logo} className="logo" alt="Q^3 Logo" />
        </div>
      </div>
    </div>
    <div className="speaker-box">
      <div className="speaker-photo">
         <img src={jonathan} alt="Jonathan Waldorf" className="speakerspic"/>
      </div>
      <div className="speaker-content">
      <h1>Jonathan Waldorf</h1>
      <h2>Student at Harvard University</h2>
    </div>  
    </div>
    <div className="speaker-content">
      <p className="p">
        Jonathan Waldorf is a student at Harvard University studying Electrical Engineering. At QuEra, he made an open-source python library that renders quantum circuits and neutral-atom quantum computer operations in Manim, an animation software used by 3Blue1Brown. He is passionate about science communication and loves to chat about popularizing science to the public.
      </p>
    </div>
    </>
  );
}

export default Jonathan;